import { useState } from "react";
import { Volume2, Play } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { getVolume, setVolume, play, unlockAudio, soundReady, SOUND_LABELS } from "@/lib/sound";

export default function SoundSettings() {
  const [vol, setVol] = useState(getVolume());
  const [checked, setChecked] = useState(false);
  const change = ([v]) => { setVol(v); setVolume(v); };
  const soundCheck = () => {
    unlockAudio();
    SOUND_LABELS.forEach(([k], i) => setTimeout(() => play(k), i * 1800));
    setChecked(true);
  };
  return (
    <div className="mx-auto grid max-w-2xl gap-4" data-testid="sound-settings">
      <div className="card-lg p-5">
        <h3 className="flex items-center gap-2 text-lg font-extrabold"><Volume2 size={18} /> Order sound volume</h3>
        <p className="mt-1 text-sm text-muted2">Also turn the device volume up and switch off silent mode. Status: <b data-testid="sound-status">{soundReady() ? "sound on" : "sound off"}</b></p>
        <div className="mt-4 flex items-center gap-4">
          <Slider value={[vol]} min={0} max={1} step={0.05} onValueChange={change} className="flex-1" data-testid="volume-slider" />
          <span className="w-12 text-right font-bold" data-testid="volume-value">{Math.round(vol * 100)}%</span>
        </div>
        <button className="btn-primary mt-4" onClick={() => play("ready")} data-testid="volume-test-btn"><Play size={16} /> Test volume</button>
      </div>
      <div className="card-lg p-5">
        <h3 className="text-lg font-extrabold">Sound check</h3>
        <p className="mt-1 text-sm text-muted2">Each order stage has its own sound. Play them one by one, or all in a row.</p>
        <div className="mt-4 grid gap-2 sm:grid-cols-2">
          {SOUND_LABELS.map(([k, l]) => <button key={k} onClick={() => play(k)} data-testid={`sound-check-${k}`}
            className="flex items-center justify-between rounded-2xl border-2 border-line px-4 py-3 text-left font-bold transition-colors hover:border-brand">{l} <Play size={16} /></button>)}
        </div>
        <button className="btn-secondary mt-4" onClick={soundCheck} data-testid="sound-check-all-btn">Play all sounds</button>
        {checked && <p className="mt-2 text-sm text-muted2" data-testid="sound-check-done">Playing all {SOUND_LABELS.length} sounds…</p>}
      </div>
    </div>
  );
}
